"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiController_1 = __importDefault(require("webc-reactcore/src/js/ApiController"));
const Reservation_1 = __importDefault(require("../Reservation"));
class ReservationAPI extends ApiController_1.default {
    static getBaseEndpoint() {
        return "oc-planning/reservations";
    }
    static getApiKey() {
        return "reservation";
    }
    parseFromDictionary(dictionary) {
        return __awaiter(this, void 0, void 0, function* () {
            const start = dictionary.start;
            const end = dictionary.end;
            const availableTimeslotID = dictionary.availableTimeslotID;
            const cancelled = dictionary.cancelled;
            const attachedInfo = dictionary.attachedInfo;
            this.setData(new Reservation_1.default(start, end, availableTimeslotID, attachedInfo, cancelled));
        });
    }
}
exports.default = ReservationAPI;
//# sourceMappingURL=ReservationAPI.js.map